import Modal from "../common/ui/modal";

const DeleteTag = ({tag, removeTag}) => {

    return (
        <>
            <Modal
                showButtonLabel={"Delete"}
                title="Delete Tag"
                content={[{
                    text: `Are you sure you wish to delete the below tag?`,
                    classes: ""
                }, {
                    text: `${tag?.text}`,
                    classes: "text-blue font-bold"
                }]}
                confirmButtonLabel="Confirm Delete"
                showIcon={false}
                handleConfirm={() => {
                    removeTag(tag)
                }}
            />
        </>
    )
}

export default DeleteTag
